var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99978 15.1843L6.64415 16.6195C6.01221 16.8855 5.41304 16.8329 4.84665 16.4616C4.28026 16.0904 3.99707 15.5647 3.99707 14.8845V4.2264C3.99707 3.70168 4.18186 3.25452 4.55145 2.88494C4.92103 2.51536 5.36818 2.33057 5.8929 2.33057H14.1067C14.6314 2.33057 15.0785 2.51536 15.4481 2.88494C15.8177 3.25452 16.0025 3.70168 16.0025 4.2264V14.8845C16.0025 15.5647 15.7193 16.0904 15.1529 16.4616C14.5865 16.8329 13.9873 16.8855 13.3554 16.6195L9.99978 15.1843Z",
    fill: "#053692"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookmark);
export default __webpack_public_path__ + "static/media/icon_bookmark.4db0760c0305e99f253952ac4bf8fa08.svg";
export { ForwardRef as ReactComponent };